import React from "react";
import { FlatList, View, Text } from "react-native";
import { getOptionsStyles } from "./styles";
import { SelectedLineOptions } from "@/app/types/option";
import { useTranslateText } from "@/app/utils/translations";
import { getChoiceText } from "@/app/utils/options";

type OptionsProps = {
  lineOptions: SelectedLineOptions[];
  isBasketItemSelected: boolean;
};

const Options = ({
  lineOptions,
  isBasketItemSelected,
}: OptionsProps): JSX.Element => {
  const { locale } = useTranslateText();
  const styles = getOptionsStyles(isBasketItemSelected);

  return (
    <View style={styles.container}>
      <View style={styles.container} />
      <View style={styles.listContainer}>
        <FlatList
          keyExtractor={({ lineId }) => `${lineId}`}
          data={lineOptions}
          renderItem={({ item }) => {
            return (
              <Text style={styles.optionText}>
                {getChoiceText(item, locale)}
              </Text>
            );
          }}
        />
      </View>
    </View>
  );
};

export default Options;
